import * as React from 'react';

import masks from 'v2/components/Shared/Masks';

const useMask = (mask?: string, value?: any) => {
  if (!masks) throw new Error('You must provide a valid masks');

  const { apply: maskApply, clean: maskClean } = React.useMemo(() => {
    let maskFunc = (masks || []).find(m => m.name === mask);

    if (!maskFunc) {
      maskFunc = { name: 'not-found', apply: (v: string) => v, clean: v => v };

      if (mask) {
        console.warn(`Mask '${mask}' not found`);
      }
    }

    return maskFunc;
  }, [mask]);

  const maskedValue = React.useMemo(() => (maskApply ? maskApply(value) : value), [value, maskApply]);
  const cleanedValue = React.useMemo(() => (maskClean ? maskClean(value) : value), [value, maskClean]);

  return { maskApply, maskClean, maskedValue, cleanedValue };
};

export default useMask;
